import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';

import Founder from './Founder';

const CompanyFounders = ({ data }) => {
  return (
    <Container>
      <Box py={8} textAlign={'center'}>
        <Typography variant="h2">{data?.title}</Typography>

        <Box
          sx={{
            mt: {
              xs: 6,
              md: 8,
            },
          }}
        />
        <Grid container spacing={5}>
          {data?.founders.map((founder, key) => (
            <Grid item xs={12} sm={6} md={3} key={key}>
              <Founder data={founder} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default CompanyFounders;
